import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "../../Reusable/TextInput";
import Button from "../../Reusable/Button";
import Modal from "../../Reusable/Modal";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../../customHooks/usePatchHook";
import useGetHook from "../../../customHooks/useGetHook";
import APIS from "../../../constant/Endpoint";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddContactGroupForm } from "../../../utils/validationSchemas";

const UpdateContactGroupModal = ({
  isOpen,
  setIsOpen,
  id,
}: {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  id: string | number;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({
    resolver: yupResolver(AddContactGroupForm)
  });

  // Fetch existing contact group data
  const { data, refetch } = useGetHook({
    queryKey: [`contact-group-${id}`],
    url: `${APIS.CONTACT_GROUP}${id}/`,
    params: {},
  });

  
  useEffect(() => {
    if (data) {
      reset({ name: data.name });
    }
  }, [data, reset]);

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: [`contact-group-${id}`],
    navigateURL: "",
  });

  const handleEdit = async (values: any) => {
    const url = `${APIS.CONTACT_GROUP}${id}/`;
    const formData = { ...values };
    try {
      await mutateAsync({ url, formData, setError });
      setIsOpen(false);
      refetch();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Update Contact Group">
      <div className={tw`flex flex-col items-center w-[600px]`}>
        <form onSubmit={handleSubmit(handleEdit)} className={tw`space-y-4 mt-4 w-full`}>
          <div>
            <TextField
              label={
                <div className={tw`block text-sm font-medium mb-1`}>
                  Name <span className={tw`text-red-500`}>*</span>
                </div>
              }
              placeholder="Enter group name"
              register={register("name")}
              errors={errors?.name}
            />
          </div>

          <div className={tw`flex justify-center items-center gap-4 pt-2`}>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button
                label="Cancel"
                onClick={() => setIsOpen(false)}
                variant="secondary"
                type="button"
              />
            </div>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button label="Update" type="submit" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default UpdateContactGroupModal;
